import type { ITableHeader } from "@/shared/components"

export const energyPassportQuarterTableHeaders: ITableHeader[][] = [
  [
    { label: "Квартал", rowSpan: 2, className: "min-w-[150px]" },
    { label: "Продукт", rowSpan: 2 },
    { label: "Производство", colSpan: 2 },
    { label: "актив", rowSpan: 2 },
    { label: "реактив", rowSpan: 2 },
    { label: "Тепловая энергия", rowSpan: 2 },
    { label: "Газ", rowSpan: 2 },
    { label: "Мазут", rowSpan: 2 },
    { label: "Уголь", rowSpan: 2 },
    { label: "Нефтепродукты", colSpan: 4, style: { textAlign: "center" } },
    { label: "Вода", rowSpan: 2, style: { textAlign: "center" } },
    { label: "", rowSpan: 2 }
  ],
  [
    { label: "Кол-во", className: "whitespace-nowrap border-t" },
    { label: "Ед. изм.", className: "whitespace-nowrap border-t" },
    { label: "Бензин", className: "border-t" },
    { label: "Дизел", className: "border-t" },
    { label: "Керосин", className: "border-t" },
    { label: "Другие", className: "border-t" }
  ]
]
